import { useMediaQuery } from 'react-responsive';
import { RESPONSIVE_BREAKPOINTS } from '../constants';

export default function useResponsive() {
  const isMobile = useMediaQuery({
    query: `(max-width: ${RESPONSIVE_BREAKPOINTS.MOBILE_MAX_WIDTH}px)`,
  });

  const isTablet = useMediaQuery({
    query: `(min-width: ${RESPONSIVE_BREAKPOINTS.TABLET_MIN_WIDTH}px) and (max-width: ${RESPONSIVE_BREAKPOINTS.TABLET_MAX_WIDTH}px)`,
  });

  const isDesktop = useMediaQuery({
    query: `(min-width: ${RESPONSIVE_BREAKPOINTS.DESKTOP_MIN_WIDTH}px)`,
  });

  return {
    isMobile, isTablet, isDesktop,
  };
}
